import React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import PlusCircleIcon from 'react-icons/lib/fa/plus-circle';

import Button from '../UIKit/Button';
import Styles from './NewProjectButton.styles';

const NewProjectButton = () => (
  <Link style={{ color: 'inherit', flex: 1 }} to="/projects/add">
    <Button size="sm" style={Styles.buttonWrapper} buttonStyle={Styles.button}>
      <PlusCircleIcon size={26} style={Styles.icon} /> New project
    </Button>
  </Link>
);

NewProjectButton.propTypes = {};

NewProjectButton.defaultProps = {};

export default Radium(NewProjectButton);



// WEBPACK FOOTER //
// ./src/components/NewProjectButton/NewProjectButton.js